import * as z from "zod";
//#region src/__generated__/reporting/reportGenerationMarkupController/zod/dataBufferSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const dataBufferSchema = z.object({});
//#endregion
//#region src/__generated__/reporting/reportGenerationMarkupController/zod/getAllMarkupByModelIdsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getAllMarkupByModelIdsStatus200Schema = z.array(dataBufferSchema);
const getAllMarkupByModelIdsResponseSchema = getAllMarkupByModelIdsStatus200Schema;
const getAllMarkupByModelIdsDataSchema = z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" });
//#endregion
//#region src/__generated__/reporting/reportGenerationMarkupController/zod/getAllMarkupsIsProposedAsTypicalSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getAllMarkupsIsProposedAsTypicalStatus200Schema = z.array(dataBufferSchema);
const getAllMarkupsIsProposedAsTypicalResponseSchema = getAllMarkupsIsProposedAsTypicalStatus200Schema;
//#endregion
export { getAllMarkupByModelIdsStatus200Schema as a, getAllMarkupByModelIdsResponseSchema as i, getAllMarkupsIsProposedAsTypicalStatus200Schema as n, dataBufferSchema as o, getAllMarkupByModelIdsDataSchema as r, getAllMarkupsIsProposedAsTypicalResponseSchema as t };

//# sourceMappingURL=getAllMarkupsIsProposedAsTypicalSchema.js.map